import Button from 'components/Button'
import Header from 'components/Typography/Header'
import Paragraph from 'components/Typography/Paragraph'
import {Link} from 'react-router-dom'
import { ArrowRight, CheckCircle, Star, Zap, Shield, Clock, Users } from 'lucide-react'
const Hero = () => {
    return (
        <section className='relative min-h-[900px] flex items-center py-24 overflow-hidden'>


            <div className='relative z-20 max-w-7xl mx-auto px-6 w-full'>
                <div className='grid grid-cols-12 gap-8 items-center'>
                    {/* Left Content */}
                    <div className='lg:col-start-1 lg:col-end-8 col-start-1 col-end-13 space-y-10'>
                        {/* Badge */}
                        <div className="inline-flex items-center space-x-2 bg-primary/10 border border-primary/20 rounded-full px-6 py-3">
                            <Star className="text-primary" size={18} />
                            <span className="text-primary font-medium">Türkiye'nin En Güvenilir Dijital Ödeme Platformu</span>
                        </div>

                        {/* Main Heading */}
                        <div className="space-y-6">
                            <Header level={4} className="text-primary font-semibold tracking-wide text-xl">Dijital Ödeme Çözümleri</Header>
                            <Header level={1} className="text-white font-bold leading-tight text-5xl lg:text-6xl">
                                Anında Teslimat ile{' '}
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
                                    Güvenli İşlemler
                                </span>
                            </Header>
                        </div>

                        {/* Description */}
                        <Paragraph size="large" className="text-gray-300 leading-relaxed text-xl max-w-2xl">
                            SkyPay ile Bigo Live elmas, oyun kredileri, e-pin kodları ve dijital içerikleri güvenli, hızlı ve kolay bir şekilde satın alın. 5 dakika içinde anında teslimat garantisi.
                        </Paragraph>

                        {/* Features Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 py-6">
                            <div className="flex items-center space-x-4 p-4 bg-gray-800/50 rounded-xl border border-gray-700/50">
                                <div className="w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center">
                                    <Clock className="text-green-400" size={20} />
                                </div>
                                <span className="text-gray-300 font-medium">5 Dakikada Anında Teslimat</span>
                            </div>
                            <div className="flex items-center space-x-4 p-4 bg-gray-800/50 rounded-xl border border-gray-700/50">
                                <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center">
                                    <Shield className="text-blue-400" size={20} />
                                </div>
                                <span className="text-gray-300 font-medium">SSL Sertifikalı Güvenlik</span>
                            </div>
                            <div className="flex items-center space-x-4 p-4 bg-gray-800/50 rounded-xl border border-gray-700/50">
                                <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center">
                                    <Users className="text-primary" size={20} />
                                </div>
                                <span className="text-gray-300 font-medium">7/24 Canlı Müşteri Desteği</span>
                            </div>
                            <div className="flex items-center space-x-4 p-4 bg-gray-800/50 rounded-xl border border-gray-700/50">
                                <div className="w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center">
                                    <Zap className="text-purple-400" size={20} />
                                </div>
                                <span className="text-gray-300 font-medium">Çoklu Ödeme Yöntemleri</span>
                            </div>
                        </div>

                        {/* CTA Buttons */}
                        <div className='flex flex-col sm:flex-row gap-6 pt-8'>
                            <Link to="/register">
                                <Button className="bg-gradient-to-r from-primary to-secondary hover:from-primary/90 hover:to-secondary/90 text-white font-semibold px-10 py-5 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center space-x-3 text-lg">
                                    <span>Hemen Başla</span>
                                    <ArrowRight size={22} />
                                </Button>
                            </Link>
                            <Link to="/login/customer">
                                <Button variant="secondary" className="border-2 border-gray-600 text-gray-300 hover:border-primary hover:text-primary bg-transparent font-semibold px-10 py-5 rounded-xl transition-all duration-200 text-lg">
                                    Giriş Yap
                                </Button>
                            </Link>
                        </div>
                    </div>

                    {/* Right Visual Content */}
                    <div className='lg:col-start-8 lg:col-end-13 col-start-1 col-end-13 mt-16 lg:mt-0'>
                        <div className="relative">
                            {/* Main Card */}
                            <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-3xl border border-gray-700/50 shadow-2xl">
                                <div className="space-y-6">
                                    <div className="flex items-center justify-between">
                                        <h3 className="text-white font-bold text-xl">SkyPay Dashboard</h3>
                                        <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
                                    </div>

                                    {/* Stats */}
                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="bg-primary/10 p-4 rounded-xl border border-primary/20">
                                            <div className="text-primary font-bold text-2xl">50K+</div>
                                            <div className="text-gray-400 text-sm">Aktif Kullanıcı</div>
                                        </div>
                                        <div className="bg-green-500/10 p-4 rounded-xl border border-green-500/20">
                                            <div className="text-green-400 font-bold text-2xl">99.9%</div>
                                            <div className="text-gray-400 text-sm">Uptime</div>
                                        </div>
                                        <div className="bg-blue-500/10 p-4 rounded-xl border border-blue-500/20">
                                            <div className="text-blue-400 font-bold text-2xl">5 Dk</div>
                                            <div className="text-gray-400 text-sm">Teslimat</div>
                                        </div>
                                        <div className="bg-purple-500/10 p-4 rounded-xl border border-purple-500/20">
                                            <div className="text-purple-400 font-bold text-2xl">24/7</div>
                                            <div className="text-gray-400 text-sm">Destek</div>
                                        </div>
                                    </div>

                                    {/* Transaction Preview */}
                                    <div className="space-y-3">
                                        <h4 className="text-gray-300 font-medium">Son İşlemler</h4>
                                        <div className="space-y-2">
                                            <div className="flex items-center justify-between p-3 bg-gray-800/50 rounded-lg">
                                                <div className="flex items-center space-x-3">
                                                    <div className="w-8 h-8 bg-primary/20 rounded-full flex items-center justify-center">
                                                        <Zap size={16} className="text-primary" />
                                                    </div>
                                                    <span className="text-gray-300 text-sm">Bigo Live Elmas</span>
                                                </div>
                                                <span className="text-green-400 text-sm font-medium">Tamamlandı</span>
                                            </div>
                                            <div className="flex items-center justify-between p-3 bg-gray-800/50 rounded-lg">
                                                <div className="flex items-center space-x-3">
                                                    <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center">
                                                        <Shield size={16} className="text-blue-400" />
                                                    </div>
                                                    <span className="text-gray-300 text-sm">Steam Wallet</span>
                                                </div>
                                                <span className="text-green-400 text-sm font-medium">Tamamlandı</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Floating Elements */}
                            <div className="absolute -top-4 -right-4 w-16 h-16 bg-gradient-to-r from-primary to-secondary rounded-2xl flex items-center justify-center shadow-lg">
                                <Star className="text-white" size={24} />
                            </div>
                            <div className="absolute -bottom-4 -left-4 w-12 h-12 bg-gradient-to-r from-green-500 to-blue-500 rounded-xl flex items-center justify-center shadow-lg">
                                <CheckCircle className="text-white" size={20} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero